// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonQuillBox .ql-editor {
    min-height: 300px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: auto;
}

.commonQuillBox .ql-snow .ql-tooltip {
    top: 0 !important;
    left: 0 !important;
    margin-top: 0 !important;
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

.commonQuillBox .ql-snow .ql-tooltip::before,
.commonQuillBox .ql-snow .ql-tooltip a.ql-action::after,
.commonQuillBox .ql-snow .ql-tooltip a.ql-remove::before {
    margin: 0;
}

.commonQuillBox .ql-snow .ql-tooltip.ql-hidden {
    display: none !important;
}

.commonQuillBox .ql-container {
    border-radius: 0 0 var(--radius-1) var(--radius-1);
    height: auto !important;
    font-family: var(--font-family-base);
}

.commonQuillBox .ql-toolbar.ql-snow {
    border-radius: var(--radius-1) var(--radius-1) 0 0;
    font-family: var(--font-family-base);
}

.commonQuillBox .ql-editor,
.ql-editor.frontend {
    text-align: start;
}

.commonQuillBox .ql-editor h2,
.commonQuillBox .ql-editor h3,
.commonQuillBox .ql-editor h4,
.commonQuillBox .ql-editor .ql-size-huge,
.commonQuillBox .ql-editor .ql-size-large,
.commonQuillBox .ql-editor p,
.commonQuillBox .ql-editor li,
.commonQuillBox .ql-editor .ql-size-small {
    line-height: normal;
    color: var(--common-text-color);
}

.commonQuillBox .ql-snow .ql-editor h1,
.ql-editor.frontend h1 {
    font-size: 28px;
}

.commonQuillBox .ql-snow .ql-editor h2,
.ql-editor.frontend h2 {
    font-size: 26px;
}

.commonQuillBox .ql-snow .ql-editor h3,
.ql-editor.frontend h3 {
    font-size: 24px;
}

.commonQuillBox .ql-snow .ql-editor h4,
.ql-editor.frontend h4 {
    font-size: 22px;
}

.commonQuillBox .ql-snow .ql-editor .ql-size-huge,
.ql-editor.frontend .ql-size-huge {
    font-size: 20px;
}

.commonQuillBox .ql-snow .ql-editor .ql-size-large,
.ql-editor.frontend .ql-size-large {
    font-size: 18px;
}

.commonQuillBox .ql-snow .ql-editor p,
.commonQuillBox .ql-snow .ql-editor li,
.ql-editor.frontend p,
.ql-editor.frontend li {
    font-size: 16px;
}

.commonQuillBox .ql-snow .ql-editor .ql-size-small,
.ql-editor.frontend .ql-size-small {
    font-size: 14px;
}

.ql-editor.frontend {
    padding: 0;
    overflow: unset;
}

.commonQuillBox .ql-snow .ql-stroke {
    stroke: var(--common-text-color);
}

.commonQuillBox .ql-snow .ql-picker {
    color: var(--common-text-color);
}

.commonQuillBox .ql-snow .ql-fill {
    fill: var(--common-text-color);
}

.commonQuillBox .ql-editor.ql-blank::before {
    color: rgb(255 254 254 / 60%);
}

.commonQuillBox .ql-snow .ql-picker-options {
    background-color: var(--primary-white-bg);
}

.commonQuillBox .ql-snow .ql-editor a,
.ql-editor.frontend a {
    color: var(--common-link-color);
}

.commonQuillBox .ql-editor .ql-indent-1,
.ql-editor.frontend .ql-indent-1 {
    padding-left: 6px;
}

.commonQuillBox .ql-editor li.ql-indent-1,
.ql-editor.frontend li.ql-indent-1 {
    padding-left: 8px;
}

.commonQuillBox .ql-editor .ql-indent-2,
.ql-editor.frontend .ql-indent-2 {
    padding-left: 12px;
}

.commonQuillBox .ql-editor li.ql-indent-2,
.ql-editor.frontend li.ql-indent-2 {
    padding-left: 16px;
}

.commonQuillBox .ql-editor .ql-indent-3,
.ql-editor.frontend .ql-indent-3 {
    padding-left: 18px;
}

.commonQuillBox .ql-editor li.ql-indent-3,
.ql-editor.frontend li.ql-indent-3 {
    padding-left: 24px;
}

.commonQuillBox .ql-editor .ql-indent-4,
.ql-editor.frontend .ql-indent-4 {
    padding-left: 24px;
}

.commonQuillBox .ql-editor li.ql-indent-4,
.ql-editor.frontend li.ql-indent-4 {
    padding-left: 32px;
}

.commonQuillBox .ql-editor .ql-indent-5,
.ql-editor.frontend .ql-indent-5 {
    padding-left: 30px;
}

.commonQuillBox .ql-editor li.ql-indent-5,
.ql-editor.frontend li.ql-indent-5 {
    padding-left: 40px;
}

.commonQuillBox .ql-editor .ql-indent-6,
.ql-editor.frontend .ql-indent-6 {
    padding-left: 36px;
}

.commonQuillBox .ql-editor li.ql-indent-6,
.ql-editor.frontend li.ql-indent-6 {
    padding-left: 48px;
}

.commonQuillBox .ql-editor .ql-indent-7,
.ql-editor.frontend .ql-indent-7 {
    padding-left: 42px;
}

.commonQuillBox .ql-editor li.ql-indent-7,
.ql-editor.frontend li.ql-indent-7 {
    padding-left: 56px;
}

.commonQuillBox .ql-editor .ql-indent-8,
.ql-editor.frontend .ql-indent-8 {
    padding-left: 48px;
}

.commonQuillBox .ql-editor li.ql-indent-8,
.ql-editor.frontend li.ql-indent-8 {
    padding-left: 64px;
}

.commonQuillBox .ql-editor .ql-indent-9,
.ql-editor.frontend .ql-indent-9 {
    padding-left: 54px;
}

.commonQuillBox .ql-editor li.ql-indent-9,
.ql-editor.frontend li.ql-indent-9 {
    padding-left: 72px;
}

/* rtl */

.rtl .commonQuillBox .ql-snow .ql-tooltip {
    left: unset !important;
    right: 0 !important;
}

.rtl .ql-editor.frontend {
    padding-right: 2px;
}

.rtl .commonQuillBox .ql-editor li>span::before,
.rtl .ql-editor.frontend li>span::before {
    margin-left: 0.3em;
    margin-right: -1.5em;
    text-align: left;
}

.rtl .commonQuillBox .ql-toolbar.ql-snow .ql-formats {
    margin-right: unset;
    margin-left: 15px;
}

.rtl .commonQuillBox .ql-editor ol,
.rtl .commonQuillBox .ql-editor ul,
.rtl .ql-editor.frontend ol,
.rtl .ql-editor.frontend ul {
    padding-left: unset;
    padding-right: 1.5em;
}

.rtl .commonQuillBox .ql-editor ol li,
.rtl .commonQuillBox .ql-editor ul li,
.rtl .ql-editor.frontend ol li,
.rtl .ql-editor.frontend ul li {
    padding-left: unset;
    padding-right: 1.5em;
}

.rtl .commonQuillBox .ql-editor .ql-indent-1,
.rtl .ql-editor.frontend .ql-indent-1 {
    padding-left: unset;
    padding-right: 6px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-1,
.rtl .ql-editor.frontend li.ql-indent-1 {
    padding-left: unset;
    padding-right: 8px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-2,
.rtl .ql-editor.frontend .ql-indent-1 {
    padding-left: unset;
    padding-right: 12px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-2,
.rtl .ql-editor.frontend li.ql-indent-2 {
    padding-left: unset;
    padding-right: 16px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-3,
.rtl .ql-editor.frontend .ql-indent-1 {
    padding-left: unset;
    padding-right: 18px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-3,
.rtl .ql-editor.frontend li.ql-indent-3 {
    padding-left: unset;
    padding-right: 24px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-4,
.rtl .ql-editor.frontend .ql-indent-1 {
    padding-left: unset;
    padding-right: 24px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-4,
.rtl .ql-editor.frontend li.ql-indent-4 {
    padding-left: unset;
    padding-right: 32px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-5,
.rtl .ql-editor.frontend .ql-indent-5 {
    padding-left: unset;
    padding-right: 30px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-5,
.rtl .ql-editor.frontend li.ql-indent-5 {
    padding-left: unset;
    padding-right: 40px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-6,
.rtl .ql-editor.frontend .ql-indent-6 {
    padding-left: unset;
    padding-right: 36px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-6,
.rtl .ql-editor.frontend li.ql-indent-6 {
    padding-left: unset;
    padding-right: 48px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-7,
.rtl .ql-editor.frontend .ql-indent-7 {
    padding-left: unset;
    padding-right: 42px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-7,
.rtl .ql-editor.frontend li.ql-indent-7 {
    padding-left: unset;
    padding-right: 56px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-8,
.rtl .ql-editor.frontend .ql-indent-8 {
    padding-left: unset;
    padding-right: 48px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-8,
.rtl .ql-editor.frontend li.ql-indent-8 {
    padding-left: unset;
    padding-right: 64px;
}

.rtl .commonQuillBox .ql-editor .ql-indent-9,
.rtl .ql-editor.frontend .ql-indent-9 {
    padding-left: unset;
    padding-right: 54px;
}

.rtl .commonQuillBox .ql-editor li.ql-indent-9,
.rtl .ql-editor.frontend li.ql-indent-9 {
    padding-left: unset;
    padding-right: 72px;
}

.rtl .commonQuillBox .ql-editor blockquote,
.rtl .ql-editor.frontend blockquote {
    padding-left: unset;
    padding-right: 16px;
    border-left: unset;
    border-right: 4px solid #ccc;
}

.rtl .commonQuillBox .ql-snow .ql-picker-label,
.rtl .ql-editor.frontend .ql-picker-label {
    padding-left: 2px;
    padding-right: 8px;
    text-align: left;
}

.rtl .ql-snow.ql-toolbar button,
.rtl .ql-snow .ql-toolbar button {
    float: right;
}`, "",{"version":3,"sources":["webpack://./src/styles/customQuillEditor.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;;;IAGI,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kDAAkD;IAClD,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,kDAAkD;IAClD,oCAAoC;AACxC;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;;;;;;;IAQI,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;;;IAII,eAAe;AACnB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;;IAEI,+BAA+B;AACnC;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA,QAAQ;;AAER;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;;;;IAII,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;;;IAII,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,YAAY;AAChB","sourcesContent":[".commonQuillBox .ql-editor {\n    min-height: 300px;\n    max-height: 300px;\n    overflow-y: auto;\n    overflow-x: auto;\n}\n\n.commonQuillBox .ql-snow .ql-tooltip {\n    top: 0 !important;\n    left: 0 !important;\n    margin-top: 0 !important;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 5px;\n}\n\n.commonQuillBox .ql-snow .ql-tooltip::before,\n.commonQuillBox .ql-snow .ql-tooltip a.ql-action::after,\n.commonQuillBox .ql-snow .ql-tooltip a.ql-remove::before {\n    margin: 0;\n}\n\n.commonQuillBox .ql-snow .ql-tooltip.ql-hidden {\n    display: none !important;\n}\n\n.commonQuillBox .ql-container {\n    border-radius: 0 0 var(--radius-1) var(--radius-1);\n    height: auto !important;\n    font-family: var(--font-family-base);\n}\n\n.commonQuillBox .ql-toolbar.ql-snow {\n    border-radius: var(--radius-1) var(--radius-1) 0 0;\n    font-family: var(--font-family-base);\n}\n\n.commonQuillBox .ql-editor,\n.ql-editor.frontend {\n    text-align: start;\n}\n\n.commonQuillBox .ql-editor h2,\n.commonQuillBox .ql-editor h3,\n.commonQuillBox .ql-editor h4,\n.commonQuillBox .ql-editor .ql-size-huge,\n.commonQuillBox .ql-editor .ql-size-large,\n.commonQuillBox .ql-editor p,\n.commonQuillBox .ql-editor li,\n.commonQuillBox .ql-editor .ql-size-small {\n    line-height: normal;\n    color: var(--common-text-color);\n}\n\n.commonQuillBox .ql-snow .ql-editor h1,\n.ql-editor.frontend h1 {\n    font-size: 28px;\n}\n\n.commonQuillBox .ql-snow .ql-editor h2,\n.ql-editor.frontend h2 {\n    font-size: 26px;\n}\n\n.commonQuillBox .ql-snow .ql-editor h3,\n.ql-editor.frontend h3 {\n    font-size: 24px;\n}\n\n.commonQuillBox .ql-snow .ql-editor h4,\n.ql-editor.frontend h4 {\n    font-size: 22px;\n}\n\n.commonQuillBox .ql-snow .ql-editor .ql-size-huge,\n.ql-editor.frontend .ql-size-huge {\n    font-size: 20px;\n}\n\n.commonQuillBox .ql-snow .ql-editor .ql-size-large,\n.ql-editor.frontend .ql-size-large {\n    font-size: 18px;\n}\n\n.commonQuillBox .ql-snow .ql-editor p,\n.commonQuillBox .ql-snow .ql-editor li,\n.ql-editor.frontend p,\n.ql-editor.frontend li {\n    font-size: 16px;\n}\n\n.commonQuillBox .ql-snow .ql-editor .ql-size-small,\n.ql-editor.frontend .ql-size-small {\n    font-size: 14px;\n}\n\n.ql-editor.frontend {\n    padding: 0;\n    overflow: unset;\n}\n\n.commonQuillBox .ql-snow .ql-stroke {\n    stroke: var(--common-text-color);\n}\n\n.commonQuillBox .ql-snow .ql-picker {\n    color: var(--common-text-color);\n}\n\n.commonQuillBox .ql-snow .ql-fill {\n    fill: var(--common-text-color);\n}\n\n.commonQuillBox .ql-editor.ql-blank::before {\n    color: rgb(255 254 254 / 60%);\n}\n\n.commonQuillBox .ql-snow .ql-picker-options {\n    background-color: var(--primary-white-bg);\n}\n\n.commonQuillBox .ql-snow .ql-editor a,\n.ql-editor.frontend a {\n    color: var(--common-link-color);\n}\n\n.commonQuillBox .ql-editor .ql-indent-1,\n.ql-editor.frontend .ql-indent-1 {\n    padding-left: 6px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-1,\n.ql-editor.frontend li.ql-indent-1 {\n    padding-left: 8px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-2,\n.ql-editor.frontend .ql-indent-2 {\n    padding-left: 12px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-2,\n.ql-editor.frontend li.ql-indent-2 {\n    padding-left: 16px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-3,\n.ql-editor.frontend .ql-indent-3 {\n    padding-left: 18px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-3,\n.ql-editor.frontend li.ql-indent-3 {\n    padding-left: 24px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-4,\n.ql-editor.frontend .ql-indent-4 {\n    padding-left: 24px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-4,\n.ql-editor.frontend li.ql-indent-4 {\n    padding-left: 32px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-5,\n.ql-editor.frontend .ql-indent-5 {\n    padding-left: 30px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-5,\n.ql-editor.frontend li.ql-indent-5 {\n    padding-left: 40px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-6,\n.ql-editor.frontend .ql-indent-6 {\n    padding-left: 36px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-6,\n.ql-editor.frontend li.ql-indent-6 {\n    padding-left: 48px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-7,\n.ql-editor.frontend .ql-indent-7 {\n    padding-left: 42px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-7,\n.ql-editor.frontend li.ql-indent-7 {\n    padding-left: 56px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-8,\n.ql-editor.frontend .ql-indent-8 {\n    padding-left: 48px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-8,\n.ql-editor.frontend li.ql-indent-8 {\n    padding-left: 64px;\n}\n\n.commonQuillBox .ql-editor .ql-indent-9,\n.ql-editor.frontend .ql-indent-9 {\n    padding-left: 54px;\n}\n\n.commonQuillBox .ql-editor li.ql-indent-9,\n.ql-editor.frontend li.ql-indent-9 {\n    padding-left: 72px;\n}\n\n/* rtl */\n\n.rtl .commonQuillBox .ql-snow .ql-tooltip {\n    left: unset !important;\n    right: 0 !important;\n}\n\n.rtl .ql-editor.frontend {\n    padding-right: 2px;\n}\n\n.rtl .commonQuillBox .ql-editor li>span::before,\n.rtl .ql-editor.frontend li>span::before {\n    margin-left: 0.3em;\n    margin-right: -1.5em;\n    text-align: left;\n}\n\n.rtl .commonQuillBox .ql-toolbar.ql-snow .ql-formats {\n    margin-right: unset;\n    margin-left: 15px;\n}\n\n.rtl .commonQuillBox .ql-editor ol,\n.rtl .commonQuillBox .ql-editor ul,\n.rtl .ql-editor.frontend ol,\n.rtl .ql-editor.frontend ul {\n    padding-left: unset;\n    padding-right: 1.5em;\n}\n\n.rtl .commonQuillBox .ql-editor ol li,\n.rtl .commonQuillBox .ql-editor ul li,\n.rtl .ql-editor.frontend ol li,\n.rtl .ql-editor.frontend ul li {\n    padding-left: unset;\n    padding-right: 1.5em;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-1,\n.rtl .ql-editor.frontend .ql-indent-1 {\n    padding-left: unset;\n    padding-right: 6px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-1,\n.rtl .ql-editor.frontend li.ql-indent-1 {\n    padding-left: unset;\n    padding-right: 8px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-2,\n.rtl .ql-editor.frontend .ql-indent-1 {\n    padding-left: unset;\n    padding-right: 12px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-2,\n.rtl .ql-editor.frontend li.ql-indent-2 {\n    padding-left: unset;\n    padding-right: 16px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-3,\n.rtl .ql-editor.frontend .ql-indent-1 {\n    padding-left: unset;\n    padding-right: 18px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-3,\n.rtl .ql-editor.frontend li.ql-indent-3 {\n    padding-left: unset;\n    padding-right: 24px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-4,\n.rtl .ql-editor.frontend .ql-indent-1 {\n    padding-left: unset;\n    padding-right: 24px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-4,\n.rtl .ql-editor.frontend li.ql-indent-4 {\n    padding-left: unset;\n    padding-right: 32px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-5,\n.rtl .ql-editor.frontend .ql-indent-5 {\n    padding-left: unset;\n    padding-right: 30px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-5,\n.rtl .ql-editor.frontend li.ql-indent-5 {\n    padding-left: unset;\n    padding-right: 40px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-6,\n.rtl .ql-editor.frontend .ql-indent-6 {\n    padding-left: unset;\n    padding-right: 36px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-6,\n.rtl .ql-editor.frontend li.ql-indent-6 {\n    padding-left: unset;\n    padding-right: 48px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-7,\n.rtl .ql-editor.frontend .ql-indent-7 {\n    padding-left: unset;\n    padding-right: 42px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-7,\n.rtl .ql-editor.frontend li.ql-indent-7 {\n    padding-left: unset;\n    padding-right: 56px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-8,\n.rtl .ql-editor.frontend .ql-indent-8 {\n    padding-left: unset;\n    padding-right: 48px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-8,\n.rtl .ql-editor.frontend li.ql-indent-8 {\n    padding-left: unset;\n    padding-right: 64px;\n}\n\n.rtl .commonQuillBox .ql-editor .ql-indent-9,\n.rtl .ql-editor.frontend .ql-indent-9 {\n    padding-left: unset;\n    padding-right: 54px;\n}\n\n.rtl .commonQuillBox .ql-editor li.ql-indent-9,\n.rtl .ql-editor.frontend li.ql-indent-9 {\n    padding-left: unset;\n    padding-right: 72px;\n}\n\n.rtl .commonQuillBox .ql-editor blockquote,\n.rtl .ql-editor.frontend blockquote {\n    padding-left: unset;\n    padding-right: 16px;\n    border-left: unset;\n    border-right: 4px solid #ccc;\n}\n\n.rtl .commonQuillBox .ql-snow .ql-picker-label,\n.rtl .ql-editor.frontend .ql-picker-label {\n    padding-left: 2px;\n    padding-right: 8px;\n    text-align: left;\n}\n\n.rtl .ql-snow.ql-toolbar button,\n.rtl .ql-snow .ql-toolbar button {\n    float: right;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
